import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../context/AppContext";
import MasterLayout from "../masterLayout/MasterLayout";
import EventsCalendar from "../components/custom/events/EventsCalendar";
import ViewEvents from "../components/custom/events/ViewEvents";

export const EVENT_TYPES = [
  { value: "birthday", label: "Birthday", tone: "success" },
  { value: "wedding", label: "Wedding", tone: "success" },
  { value: "engagement", label: "Engagement", tone: "success" },
  { value: "anniversary", label: "Anniversary", tone: "success" },

  { value: "conference", label: "Conference", tone: "info" },
  { value: "seminar", label: "Seminar", tone: "info" },
  { value: "meeting", label: "Meeting", tone: "info" },

  { value: "party", label: "Party", tone: "danger" },
  { value: "concert", label: "Concert", tone: "danger" },

  { value: "festival", label: "Festival", tone: "warning" },
  { value: "other", label: "Other", tone: "default" },
];

export default function EventsPage() {
  const { eventsList } = useContext(AppContext);
  const [view, setView] = useState("calendar");
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [rows, setRows] = useState(null);

  const fmt = {
    short: (d) =>
      d
        ? new Date(d).toLocaleString(undefined, {
            dateStyle: "medium",
            timeStyle: "short",
          })
        : "—",
    date: (d) =>
      d
        ? new Date(d).toLocaleDateString(undefined, { dateStyle: "medium" })
        : "—",
    time: (d) =>
      d
        ? new Date(d).toLocaleTimeString(undefined, { timeStyle: "short" })
        : "—",
  };

  const fmtShort = (d) =>
    d
      ? new Date(d).toLocaleString(undefined, {
          dateStyle: "medium",
          timeStyle: "short",
        })
      : "—";

  const handleEventsList = () => {
    if (
      !eventsList ||
      (eventsList && !Array.isArray(eventsList)) ||
      eventsList.length === 0
    )
      return;
    const data = eventsList.map((e) => ({
      ...e,
      id: String(e.event_id),
    }));

    setRows(data);
  };

  // List-view rows (keep original fields)
  useEffect(() => {
    handleEventsList();
  }, [eventsList]);

  const openModal = (eventObj) => {
    // ensure ISO strings for start/end in modal
    setSelected({
      ...eventObj,
      event_start:
        typeof eventObj.event_start === "string"
          ? eventObj.event_start
          : new Date(eventObj.event_start).toISOString(),
      event_end:
        typeof eventObj.event_end === "string"
          ? eventObj.event_end
          : new Date(eventObj.event_end).toISOString(),
    });
    setModalOpen(true);
  };

  const handleVIewEvents = (eventObj) => {
    setSelected({
      ...eventObj,
      event_start:
        typeof eventObj.event_start === "string"
          ? eventObj.event_start
          : new Date(eventObj.event_start).toISOString(),
      event_end:
        typeof eventObj.event_end === "string"
          ? eventObj.event_end
          : new Date(eventObj.event_end).toISOString(),
    });
    // setIsEditing(true);
  };

  const findEvent = (type) => {
    if (!type) return;

    return EVENT_TYPES.find((x) => x.value == type)?.tone;
  };

  return (
    <MasterLayout>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-8 col-md-6 col-sm-12">
            <h6 className="my-3 mx-3">Events List</h6>
          </div>
          <div className="d-flex justify-content-lg-start justify-content-start gap-2 my-3 mx-3 pe-3">
            <label className="view-switch" aria-label="Toggle view">
              <input
                type="checkbox"
                className="view-switch__input"
                checked={view === "list"}
                onChange={(e) =>
                  setView(e.target.checked ? "list" : "calendar")
                }
                role="switch"
                aria-checked={view === "list"}
              />
              <span className="view-switch__track">
                <span className="view-switch__thumb" />
                <span className="view-switch__text view-switch__text--left">
                  Calendar
                </span>
                <span className="view-switch__text view-switch__text--right">
                  List
                </span>
              </span>
            </label>
          </div>
        </div>

        {/* View switch */}
        {view === "calendar" ? (
          <EventsCalendar
            selected={selected}
            setSelected={setSelected}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
          />
        ) : (
          <div className={`events-flex ${selected ? "has-details" : ""}`}>
            <div className="card calendar-col shadow-sm mx-3">
              <div className="card-body p-0">
                <div className="table-responsive scroll-sm p-3">
                  <table className="table bordered-table text-sm ">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "38%" }}>Title</th>
                        <th style={{ width: "22%" }}>Start</th>
                        <th style={{ width: "22%" }}>End</th>
                        <th style={{ width: "10%" }}>Type</th>
                        <th style={{ width: "8%" }} className="text-end">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows && rows.length != 0 ? (
                        rows.map((e) => (
                          <tr key={e.id}>
                            <td>
                              <div className="fw-semibold">{e.event_title}</div>
                              <div className="text-muted small">
                                ID: {e.event_id}
                              </div>
                            </td>
                            <td>
                              <div>{fmt.date(e.event_start)}</div>
                              <div className="text-muted small">
                                {fmt.time(e.event_start)}
                              </div>
                            </td>
                            <td>
                              <div>{fmt.date(e.event_end)}</div>
                              <div className="text-muted small">
                                {fmt.time(e.event_end)}
                              </div>
                            </td>
                            <td>
                              <span
                                className={`badge text-bg-${findEvent(
                                  e.event_type
                                )}`}
                              >
                                {e.event_type}
                              </span>
                            </td>
                            <td className="text-end">
                              <button
                                className="view_btn"
                                onClick={() => handleVIewEvents(e)}
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center py-5 text-muted"
                          >
                            No events available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <ViewEvents
              fmtShort={fmtShort}
              isEditing={isEditing}
              selected={selected}
              setIsEditing={setIsEditing}
              setSelected={setSelected}
              handleEventsList={handleEventsList}
            />
          </div>
        )}
        {/* Shared Bootstrap modal for List view (Calendar already has its own) */}
        <div
          className={`modal fade ${modalOpen ? "show" : ""}`}
          style={{ display: modalOpen ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
          aria-modal={modalOpen ? "true" : "false"}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selected?.event_title ?? "Event details"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {selected ? (
                  <div className="row g-3">
                    <div className="col-12">
                      <strong>Title:</strong> {selected.event_title}
                    </div>
                    <div className="col-md-6">
                      <strong>Start:</strong> {fmt.short(selected.event_start)}
                      <div className="text-muted small">
                        {fmt.date(selected.event_start)} •{" "}
                        {fmt.time(selected.event_start)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <strong>End:</strong> {fmt.short(selected.event_end)}
                      <div className="text-muted small">
                        {fmt.date(selected.event_end)} •{" "}
                        {fmt.time(selected.event_end)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <strong>Type:</strong> {selected.event_type || "—"}
                    </div>
                    <div className="col-md-6">
                      <strong>Menu Type:</strong> {selected.menu_type || "—"}
                    </div>
                    <div className="col-md-6">
                      <strong>Menu ID:</strong> {selected.menu_id ?? "—"}
                    </div>
                    <div className="col-md-6">
                      <strong>Max Attendees:</strong>{" "}
                      {selected.maxAttendees ?? "—"}
                    </div>
                    <div className="col-md-6">
                      <strong>Active:</strong>{" "}
                      {Number(selected.active) ? "Yes" : "No"}
                    </div>
                    <div className="col-12">
                      <strong>Description:</strong>{" "}
                      {selected.event_description ?? "—"}
                    </div>
                    <div className="col-12">
                      <strong>Promotions:</strong> {selected.promotions ?? "—"}
                    </div>
                    <div className="col-12">
                      <strong>Created At:</strong>{" "}
                      {fmt.short(selected.created_at)}
                    </div>
                  </div>
                ) : (
                  <div>—</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {modalOpen && (
          <div
            className="modal-backdrop fade show"
            onClick={() => setModalOpen(false)}
          />
        )}
      </div>
    </MasterLayout>
  );
}
